import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

/**
 * Four-pointed sparkle. Used as the AI-glyph on insight banners and
 * the assistant entry button. Theme-aware — defaults to `currentColor`
 * so the parent's `color` token drives the fill.
 */
const Sparkle = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size = 20 }, ref) => (
  <svg
    ref={ref}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Prototype IC.spark — stroked sparkle (a filled thin star read as a "+"). */}
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
  </svg>
));

export default Sparkle;
